import { render, staticRenderFns } from "./FaxDetails.vue?vue&type=template&id=4ce62e29"
import script from "./FaxDetails.vue?vue&type=script&lang=js"
export * from "./FaxDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports